import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";

const namespace = "seneca/user";

export enum LinkedAccountsSource {
  DASHBOARD_ALERT = "dashboard_alert",
  SETTINGS_ALERT = "settings_alert",
  END_SESSION_MODAL = "end_session_modal",
  MEMORY_MODAL = "memory_modal",
  MEMORY_DASHBOARD = "memory_dashboard",
  LINKED_ACCOUNTS_PAGE = "linked_accounts_page",
  COMPLETE_ACCOUNT_MODAL = "complete_account_modal"
}

export type AnalyticsPayload = {
  source: LinkedAccountsSource;
};

export function logRecoveryEmailAdded(payload: AnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${namespace}/addRecoveryEmail`,
    payload
  });
}

export function logRecoveryEmailRemoved() {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${namespace}/removeRecoveryEmail`,
    payload: {}
  });
}

export function logRecoveryEmailConfirmed(payload: AnalyticsPayload) {
  return pushEnrichedEventToDataLayerWithCleanUp({
    event: `${namespace}/confirmRecoveryEmail`,
    payload
  });
}
